// extracted by mini-css-extract-plugin
export default {"home":"Home_home__dPAOF","search_form":"Home_search_form__3Spo4","noPosts":"Home_noPosts__ZEWf+"};